import { render, staticRenderFns } from "./progress.vue?vue&type=template&id=fb227b68&"
import script from "./progress.vue?vue&type=script&lang=ts&"
export * from "./progress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports